import {PrintStorySeverity} from './types'

export const severityBadgeClass = (severity: PrintStorySeverity): string => {
  switch (severity) {
    case 'success':
      return 'badge-light-success'
    case 'info':
      return 'badge-light-primary'
    case 'warning':
      return 'badge-light-warning'
    case 'danger':
      return 'badge-light-danger'
    default:
      return 'badge-light-secondary'
  }
}

export const severityTextClass = (severity: PrintStorySeverity): string => {
  switch (severity) {
    case 'success':
      return 'text-success'
    case 'info':
      return 'text-primary'
    case 'warning':
      return 'text-warning'
    case 'danger':
      return 'text-danger'
    default:
      return 'text-muted'
  }
}

export const severityBarColor = (severity: PrintStorySeverity): string => {
  switch (severity) {
    case 'success':
      return '#50cd89'
    case 'info':
      return '#009ef7'
    case 'warning':
      return '#ffc700'
    case 'danger':
      return '#f1416c'
    default:
      return '#a1a5b7'
  }
}

export const jobStatusBarColor = (status: string): string => {
  switch (String(status || '').toLowerCase()) {
    case 'completed':
      return '#50cd89'
    case 'failed':
    case 'blocked':
    case 'callback_missing':
      return '#f1416c'
    case 'published':
    case 'pending':
      return '#ffc700'
    default:
      return '#a1a5b7'
  }
}
